// extracted by mini-css-extract-plugin
module.exports = {"intervalPickerForm":"IntervalComparisonPicker_intervalPickerForm__3MwCD","popover":"IntervalComparisonPicker_popover__nqVrl"};